import { useQuery } from '@tanstack/vue-query';
import { computed, Ref } from 'vue';

import sensitiveCredentialsApi from '~/services/sensitive-credentials-api/sensitive-credentials-api';

export default function usePartnerCredentials(partnerId: Ref<number>) {
  return useQuery({
    enabled: computed(() => !!partnerId.value && partnerId.value > 0),
    queryFn: () => sensitiveCredentialsApi.getCredentials({ partnerId: partnerId.value }),
    queryKey: computed(() => ['partner-credentials', partnerId.value]),
    retry: 3,
  });
}
